import request from "./request";
export const http = {
  // 等级下拉列表
  healthList(params) {
    return request({
      method: 'POST',
      url: '/platform/pc/fineness/health-list',
      data: params,
    })
  },
  // 等级下拉列表
  orderHealthList(params) {
    return request({
      method: 'POST',
      url: '/platform/pc/fineness/order-health-list',
      data: params,
    })
  },
  // 外观功能项下拉列表
  faceList(params) {
    return request({
      method: 'GET',
      url: `/platform/pc/fineness/face-list?faceType=${params}`,
    })
  },
  // 成色匹配规则列表
  levelGroupList(params) {
    return request({
      method: 'POST',
      url: '/platform/pc/fineness/levelGroup-list',
      data: params,
    })
  },
  // 保存等级标签
  saveHealthCode(params) {
    return request({
      method: 'POST',
      url: '/platform/pc/fineness/save-healthCode',
      data: params,
    })
  },
  // 取消等级标签
  cancelHealthCode(params) {
    return request({
      method: 'POST',
      url: '/platform/pc/fineness/cancel-healthCode',
      data: params,
    })
  },
  // 获取-重新生成组合
  getRegroup(params) {
    return request({
      method: 'GET',
      url: '/platform/pc/fineness/get-regroup',
      params,
    })
  },
  // 重新生成组合
  setRegroup(params) {
    return request({
      method: 'POST',
      url: '/platform/pc/fineness/regroup',
      data: params,
    })
  },
  // 导出
  finenessExcel(params) {
    return request({
      method: 'post',
      url: '/platform/pc/fineness/excel',
      data: params,
      responseType: 'blob'
    })
  },
  // // 外观功能项下拉列表
  // faceList(params) {
  //   return request({
  //     method: 'GET',
  //     url: '/platform/pc/fineness/face-list',
  //     params,
  //   })
  // },
  // 绑定等级
  bindFinenessHealth(params) {
    return request({
      method: 'GET',
      url: '/platform/pc/platform/failure/bindFinenessHealth',
      params,
    })
  },
  // ai识图标签列表
  list(params) {
    return request({
      method: 'POST',
      url: '/platform/pc/ai/identify/tag/list',
      data: params,
    })
  },
  //添加保存AI试图标签
  save(params) {
    return request({
      method: 'POST',
      url: '/platform/pc/ai/identify/tag/save',
      data: params,
    })
  },
};
